import React from 'react';

import { Global, css } from '@emotion/react';
import styled from '@emotion/styled';

import { ChallengerFooter } from './footer';
import { ChallengerNav, type ChallengerNavStep } from './nav';
import { CHALLENGER as T } from './tokens';

/**
 * Figma uses Avenir Next Regular / Medium / Demi Bold.
 * Checkout previously fell back to system UI because @font-face lived only on home.
 */
const ChallengerGlobalStyles = () => (
  <Global
    styles={css`
      @font-face {
        font-family: 'Avenir Next';
        font-style: normal;
        font-weight: 400;
        font-display: swap;
        src:
          local('Avenir Next Regular'),
          local('AvenirNext-Regular'),
          url('/fonts/avenirnext-regular.woff2') format('woff2');
      }

      @font-face {
        font-family: 'Avenir Next';
        font-style: normal;
        font-weight: 500;
        font-display: swap;
        src:
          local('Avenir Next Medium'),
          local('AvenirNext-Medium'),
          url('/fonts/avenirnext-medium.woff2') format('woff2');
      }

      @font-face {
        font-family: 'Avenir Next';
        font-style: normal;
        font-weight: 600;
        font-display: swap;
        src:
          local('Avenir Next Demi Bold'),
          local('Avenir Next DemiBold'),
          local('AvenirNext-DemiBold'),
          local('Avenir Next Medium'),
          local('AvenirNext-Medium'),
          url('/fonts/avenirnext-medium.woff2') format('woff2');
      }
    `}
  />
);

const Surface = styled.div`
  min-height: 100vh;
  display: flex;
  flex-direction: column;
  background: ${T.color.bgPage};
  font-family: ${T.font.sans};
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
`;

const Main = styled.div`
  flex: 1 1 auto;
`;

type Props = {
  step?: ChallengerNavStep;
  navVariant?: 'checkout' | 'password';
  children: React.ReactNode;
};

/** Chrome shared by challenger funnel pages (nav + footer). */
export const ChallengerLayout: React.FC<Props> = ({
  step = 'storage_plan',
  navVariant = 'checkout',
  children,
}) => (
  <Surface>
    <ChallengerGlobalStyles />
    <ChallengerNav step={step} variant={navVariant} />
    <Main>{children}</Main>
    <ChallengerFooter />
  </Surface>
);
